import dayjs, { CHICAGO_TIMEZONE } from "../../utils/dayjsTimezone";

const yesNoOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

export const accidentFieldConfig = [
  {
    name: "ownerCompanyId",
    label: "Company",
    type: "combo",
    dataKey: "ownerCompanies",
  },
  {
    name: "isDriverAtFault",
    label: "Is Driver at Fault",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "status",
    label: "Status",
    type: "text",
  },
  {
    name: "date",
    label: "Date and Time",
    type: "datetime-local",
  },
  {
    name: "typeOfIncident",
    label: "Type of Incident",
    type: "text",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
  },
  {
    name: "truckId",
    label: "Truck",
    type: "combo",
    dataKey: "trucks",
  },
  {
    name: "trailerId",
    label: "Trailer",
    type: "combo",
    dataKey: "trailers",
  },
  {
    name: "claimNumber",
    label: "Claim Number",
    type: "text",
  },
  {
    name: "location",
    label: "Location",
    type: "text",
  },
  {
    name: "insurance",
    label: "Insurance",
    type: "text",
  },
  {
    name: "broker",
    label: "Broker",
    type: "text",
  },
  {
    name: "adjuster",
    label: "Adjuster",
    type: "text",
  },
  {
    name: "claimAmount",
    label: "Claim Amount",
    type: "number",
  },
  {
    name: "areWePaid",
    label: "Are We Paid",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "paidByCompany",
    label: "Company loss",
    type: "number",
  },
  {
    name: "paidByCompanyInsurance",
    label: "Paid by Company Insurance",
    type: "number",
  },
  {
    name: "paidByOtherPartyInsurance",
    label: "Paid by Other Party Insurance",
    type: "number",
  },
  {
    name: "paidByOtherParty",
    label: "Paid by Other Party",
    type: "number",
  },
  {
    name: "deductionFromDriver",
    label: "Deduction from Driver",
    type: "number",
  },
  {
    name: "hasCitation",
    label: "Has Citation",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasTowing",
    label: "Has Towing",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "towingAmount",
    label: "Towing Amount",
    type: "number",
  },
  {
    name: "hasInjury",
    label: "Has Injury",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasDrugTest",
    label: "Has Drug Test",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasPoliceReport",
    label: "Has Police Report",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "dispatcherId",
    label: "Dispatcher",
    type: "combo",
    dataKey: "dispatchers",
  },
  {
    name: "hasTotalLoss",
    label: "Has Total Loss",
    type: "select",
    options: yesNoOptions,
  },
];

export const accidentInitialValues = {
  isDriverAtFault: null,
  status: null,
  date: dayjs().tz(CHICAGO_TIMEZONE).format("YYYY-MM-DDTHH:mm"),
  typeOfIncident: null,
  description: null,
  driverId: null,
  truckId: null,
  trailerId: null,
  claimNumber: null,
  location: null,
  insurance: null,
  company: null,
  broker: null,
  adjuster: null,
  claimAmount: null,
  areWePaid: null,
  paidByCompany: null,
  paidByCompanyInsurance: null,
  paidByOtherPartyInsurance: null,
  paidByOtherParty: null,
  deductionFromDriver: null,
  hasCitation: null,
  hasTowing: null,
  towingAmount: null,
  hasInjury: null,
  hasDrugTest: null,
  hasPoliceReport: null,
  dispatcherId: null,
  hasTotalLoss: null,
  ownerCompanyId: null,
};

export const quickAccidentFieldConfig = [
  {
    name: "date",
    label: "Date and Time",
    type: "datetime-local",
  },
  {
    name: "location",
    label: "Location",
    type: "text",
  },
  {
    name: "truckId",
    label: "Truck",
    type: "combo",
    dataKey: "trucks",
  },
  {
    name: "trailerId",
    label: "Trailer",
    type: "combo",
    dataKey: "trailers",
  },
  {
    name: "ownerCompanyId",
    label: "Company",
    type: "combo",
    dataKey: "ownerCompanies",
  },
  {
    name: "driverId",
    label: "Driver",
    type: "combo",
    dataKey: "drivers",
  },
  {
    name: "description",
    label: "Description",
    type: "text",
  },
   {
    name: "hasCitation",
    label: "Has Citation",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasInjury",
    label: "Injury",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasTowing",
    label: "Towing",
    type: "select",
    options: yesNoOptions,
  },
  {
    name: "hasPoliceReport",
    label: "Police Report",
    type: "select",
    options: yesNoOptions,
  },
];

export const quickAccidentInitialValues = {
  date: accidentInitialValues.date,
  location: accidentInitialValues.location,
  truckId: accidentInitialValues.truckId,
  trailerId: accidentInitialValues.trailerId,
  company: accidentInitialValues.company,
  driverId: accidentInitialValues.driverId,
  description: accidentInitialValues.description,
  hasCitation: accidentInitialValues.hasCitation,
  hasInjury: accidentInitialValues.hasInjury,
  hasTowing: accidentInitialValues.hasTowing,
  hasPoliceReport: accidentInitialValues.hasPoliceReport,
};
